import useAtmosphere from 'hooks/useAtmosphere'

interface PainelChamadasListenerProps {
  onMessage: () => void
}

export function PainelChamadasListener(props: PainelChamadasListenerProps) {
  const { onMessage } = props
  useAtmosphere({ topic: 'painel', onMessage })
  return null
}
